module.exports = __webpack_public_path__ + "img/combine_img@2x.34db0956.png";